module.exports = __webpack_public_path__ + "e39a63afbdb9d51801b57ac3b4fba650.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-jam.png
// module id = 3197
// module chunks = 0